import React, { useState } from 'react';
import { VStack } from 'native-base';
import { Caption } from '~/shared/Typography';
import { ShopHeader } from './components/ShopHeader';
import { BrandsList } from './components/BrandsList';
import { ProductList } from './components/ProductList';
import { PromotionCarousel } from './components/PromotionCarousel';
import { useAppNavigate } from '~/pages';
import { CategoriesList } from '~/pages/shop/components/CategoriesList';
import {
    useDutchieStore,
    useI18n,
    defaultCategories,
    useTheme,
} from '@springbig/shared';
import { Section, Button } from '~/shared/Theme';

export const ShopPage = () => {

    const {
        button_primary,
        button_text,
        radius_sm,
    } = useTheme();

    const {
        filters,
        sortByProp,
        cartItemsAmount,
        isBusy,
    } = useDutchieStore();

    const { navigate, params } = useAppNavigate();
    const { t } = useI18n();

    const [isDrawerOpen, setIsDrawerOpen] =
        useState(false);

    return (
        <Section pb={cartItemsAmount ? 20 : 0} disableScroll={isDrawerOpen}>
            <VStack space={2}>
                <ShopHeader
                    isDrawerOpen={isDrawerOpen}
                    setIsDrawerOpen={(value) => setIsDrawerOpen(value)}
                />
                <CategoriesList />
                <PromotionCarousel />
                <BrandsList />
                { filters?.categories ? defaultCategories.filter((e) => filters?.categories?.includes(e?.category))?.map((e, index) =>

                    <ProductList
                        key={index}
                        {...e}
                        effect={filters?.effects}
                        strain={filters?.strainType}
                        menuSort={sortByProp?.menuSort}
                    />
                ) : defaultCategories?.map((e, index) =>

                    <ProductList
                        key={index}
                        {...e}
                        effect={filters?.effects}
                        strain={filters?.strainType}
                        menuSort={sortByProp?.menuSort}
                    />
                )}
            </VStack>
            { cartItemsAmount ?
                <Button
                    modifier={'unlocked'}
                    position={'fixed'}
                    bottom={24}
                    bg={button_primary}
                    rounded={radius_sm}
                    py={4}
                    alignSelf={'center'}
                    w={'clamp(320px, 90vw, 450px)'}
                    textAlign={'center'}
                    disabled={isBusy}
                    onPress={() => navigate(`w/${params.wallet_id}/shop/cart`)}
                >
                    <Caption color={button_text}>
                        { t('shop.view_cart') } ({ cartItemsAmount })
                    </Caption>
                </Button>
                :
                <></>
            }
        </Section>
    );
};
